import eventBus from '@/helpers/event-bus'

export function createHolder() {
    return new EventsBusHolder();
}

export function $on(event, cb) {
    eventBus.$on(event, cb);

    return () => eventBus.$off(event, cb);
}


export function $off(event) {
    eventBus.$off(event);
}

export class EventsBusHolder {
    constructor() {
        this.stopHandlers = new Map();
    }

    $on(event, cb) {
        const stopHandler = $on(event, cb);

        if (!this.stopHandlers.has(event)) {
            this.stopHandlers.set(event, []);
        }

        const stopHandlers = this.stopHandlers.get(event);
        stopHandlers.push(stopHandler);

        return () => {
            const stopHandlers = this.stopHandlers.get(event) || [];
            const index = stopHandlers.indexOf(stopHandler);
            if (index > -1) {
                stopHandlers.splice(index, 1)[0]();
            }
        };
    }

    $off(event) {
        const stopHandlers = this.stopHandlers.get(event) || [];
        stopHandlers.forEach(stopHandler => stopHandler());

        this.stopHandlers.delete(event);
    }

    clear() {
        this.stopHandlers.forEach((stopHandlers, event) => this.$off(event));
    }
}
